import { difference } from 'lodash-es'
import { initAppState, printDiff } from './manager'
import { pubSub } from './pubSub'

const skipRoomStepUpdateKeys = ['participants', 'messages']

const shouldSkipStep = (impactedState) => {
    if (!impactedState.ROOM || Object.keys(impactedState).length > 1) {
        return false
    }

    return Object.values(impactedState.ROOM).reduce((memo, room) => {
        if (memo) {
            return memo
        }

        const roomKeys = Object.keys(room)

        return difference(roomKeys, skipRoomStepUpdateKeys).length === 0
    }, false)
}

const flag = {
    beingDeprecated: true,
}

export const appState = initAppState((state) => {
    const { rootKeyChanges, impactedState, newState, steps, final } = state

    if (
        process.env.NODE_ENV === 'development' &&
        process.env.STATE_LOGGING !== 'false' &&
        !flag.beingDeprecated
    ) {
        const shouldDisplay = steps.reduce(
            (memo, { impactedState, stack, json }) => {
                const skipStep = shouldSkipStep(impactedState)

                if (skipStep) {
                    console.log(
                        'State change display omitted for:',
                        skipRoomStepUpdateKeys.join(', '),
                    )
                    return memo
                }

                printDiff(json, 'STATE CHANGE', stack)

                return true
            },
            false,
        )

        if (!shouldDisplay) {
            return
        }

        const { json: finalJSON } = final

        printDiff(finalJSON, 'CURRENT STATE')
    }

    pubSub.STATE.emit('state', state)

    rootKeyChanges.forEach((key) => {
        pubSub[key].emit(
            'state',
            {
                impacted: impactedState,
                state: newState[key],
            },
            true,
        )
    })
})
